import { getLucyWidget } from '../lib/lucy-chat'

export function LucyChatWidget() {
  const Widget = getLucyWidget()
  if (!Widget) return null
  return <Widget />
}
